import {Slider} from "@main/components/sliders/history/tiny-slider";
import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const.js";

const TOUCHEND_TIMEOUT = 300;

document.addEventListener("DOMContentLoaded", () => {
    const sliders = [{
        params: {
            container: ".js-history-slider",
            items: 1,
            gutter: 40,
            speed: 700,
            controls: false,
            nav: true,
            navPosition: "bottom",
            mouseDrag: false,
            touch: false,
            navContainer: ".js-dots-nav-container",
            loop: false,
            controlsText: ["", ""],
            navAsThumbnails: true,
            preventScrollOnTouch: "force",
            arrowKeys: true,
            responsive: {
                [LG_WIDTH]: {
                    mouseDrag: true,
                },
            },
            onInit: slider => {
                queueMicrotask(() => {
                    slider.dotsMarginByYear({
                        container: ".js-history-dots",
                        dots: ".js-history-dot"
                    });
                    slider.fillProgressBarOnInit({
                        container: ".js-history-dots",
                        filler: ".js-history-dots-filler",
                        dots: ".js-history-dot",
                    });
                })
            },
        },
        callbacks: {
            indexChanged: slider => {
                slider.fillProgressBarOnScroll({
                    container: ".js-history-dots",
                    filler: ".js-history-dots-filler",
                    dots: ".js-history-dot"
                });
                slider.changeStylePrevDots({
                    container: ".js-history-dots",
                    dots: ".js-history-dot"
                }); 
                slider.handleGoToSlideClick();
            }, 
        },
        methods: {
            refreshProgressOnResize: slider => {
                window.addEventListener("resize", () => {
                    slider.fillProgressBarOnScroll({
                        container: ".js-history-dots",
                        filler: ".js-history-dots-filler",
                        dots: ".js-history-dot"
                    });                    
                    slider.dotsMarginByYear({
                        container: ".js-history-dots",
                        dots: ".js-history-dot"
                    });
                })
            },
        }
    },{
        params: {
            loop: false,
            container: ".js-dots-nav-container",
            items: 5,
            controls: false,
            mouseDrag: true,
            nav: false,
            navAsThumbnails: false,
            arrowKeys: false,
            controlsText: ["", ""],
            touch: true,
            freezable: true,
            preventScrollOnTouch: "force",
            preventActionWhenRunning: true, 
            swipeAngle: 30,
            responsive: {
                [MD_WIDTH]: {
                    items: 9,
                },
                [LG_WIDTH]: {
                    disable: true,
                }
            },
        },
        callbacks: {            
            indexChanged: slider => {
                slider.handleGoToSlideClick();
                slider.fillProgressBarOnScroll({
                    container: ".js-history-dots",
                    filler: ".js-history-dots-filler",
                    dots: ".js-history-dot"
                });
            },
            touchMove: slider => {
                slider.fillProgressBarOnScroll({
                    container: ".js-history-dots",
                    filler: ".js-history-dots-filler",
                    dots: ".js-history-dot"
                });
            }, 
            touchEnd: slider => {
                setTimeout(() => {
                    slider.fillProgressBarOnScroll({
                        container: ".js-history-dots",
                        filler: ".js-history-dots-filler",
                        dots: ".js-history-dot"
                    });
                }, TOUCHEND_TIMEOUT); 
            }},
    },  ];

    sliders.forEach(el => {
        new Slider(el);
    });
});
